<template>
  <div v-if="showComponent">
    <vs-card class="mt-4">
      <div slot="header">
        <h3>Custo do Evento do Terceiro</h3>
      </div>

      <div class="vx-row">
        <!-- Valor FIPE -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label class="vs-input--label">Valor FIPE</label>
          <money
            class="w-full vs-inputx vs-input--input moneyStyle"
            v-model="formCustoEvento.valorFipeCadastroVeiculo"
            name="Valor FIPE"
            v-bind="moneyConfig"
          />
        </div>

        <!-- FIPE Atual -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label class="vs-input--label">FIPE Atual</label>
          <money
            class="w-full vs-inputx vs-input--input moneyStyle"
            v-model="formCustoEvento.valorFipeDiaEvento"
            name="FIPE Atual"
            v-bind="moneyConfig"
          />
        </div>

        <!-- Depreciação (%) -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label class="vs-input--label">Depreciação (%)</label>
          <money
            class="w-full vs-inputx vs-input--input moneyStyle"
            v-model="formCustoEvento.depreciacaoValor"
            name="Depreciação (%)"
            v-bind="percentConfig"
          />
        </div>

        <!-- Previsão de Valor de Reparo -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label class="vs-input--label">Previsão de Valor de Reparo</label>
          <money
            class="w-full vs-inputx vs-input--input moneyStyle"
            v-model="formCustoEvento.previsaoValorReparo"
            name="Previsão de Valor de ReparoState('Previsão de Valor de Reparo')"
            v-bind="moneyConfig"
          />
        </div>

        <!-- Custo do Evento -->
        <div class="vx-col lg:w-1/5 w-full mb-2">
          <label class="vs-input--label">Custo do Evento</label>
          <money
            class="w-full vs-inputx vs-input--input moneyStyle"
            v-model="formCustoEvento.custoReparo"
            name="Custo do Evento"
            v-bind="moneyConfig"
          />
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  props: ['formData'],
  components: { Money },
  watch: {
    formData(value) {
      if (!value.custoEvento) {
        this.showComponent = false;
        console.error(
          'ERRO NO CONTRATO DO OBJETO - CUSTO EVENTO TERCEIRO FORM',
        );
        return;
      }

      this.formCustoEvento = Object.assign(
        this.formCustoEvento,
        value.custoEvento,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.custoEvento = this.formCustoEvento;
    },
  },
  data() {
    return {
      showComponent: true,
      formCustoEvento: {
        valorFipeCadastroVeiculo: 0,
        valorFipeDiaEvento: 0,
        depreciacaoValor: 0,
        previsaoValorReparo: 0,
        custoReparo: 0,
      },

      // Configurações de Component
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
      percentConfig: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '%',
        precision: 0,
      },
    };
  },
  mounted() {
    if (!this.formData.custoEvento) {
      console.error('ERRO NO CONTRATO DO OBJETO - CUSTO EVENTO TERCEIRO FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.custoEvento = this.formCustoEvento;
  },
};
</script>

<style scoped>
.moneyStyle {
  font-size: 1rem !important;
  padding: 0.7rem !important;
}
</style>
